const swiperPartial = new Swiper('.swiper-partial', {
    direction: 'horizontal',
    slidesPerView: 1,
    grid: {
        rows: 4,
    },
    spaceBetween: 20,
    autoplay: {
        delay: 5000, // Initial autoplay delay
        disableOnInteraction: true,
    },
    loop: true,
    scrollbar: {
        el: '.swiper-partial .swiper-scrollbar', // Specific scrollbar for .swiper-partial
    },
    breakpoints: {
        640: {
            slidesPerView: 1.5,
            grid: {
                rows: 1,
            },
        },
        767: {
            slidesPerView: 2.3,
            grid: {
                rows: 1,
            },
        },
        1024: {
            slidesPerView: 3,
            grid: {
                rows: 1,
            },
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 30,
            grid: {
                rows: 1,
            },
        },
    },
});


// Initialize swiper for .swiper-full with its specific .swiper-scrollbar
const swiperFull = new Swiper('.swiper-full', {
    slidesPerView: 1.3,
    spaceBetween: 20,
    autoplay: {
        delay: 5000, // Initial autoplay delay
        disableOnInteraction: true,
    },
    scrollbar: {
        el: '.swiper-full .swiper-scrollbar', // Specific scrollbar for .swiper-full
    },
    breakpoints: {
        640: {
            slidesPerView: 1.5,
            grid: {
                rows: 1,
            },
        },
        767: {
            slidesPerView: 2.3,
            grid: {
                rows: 1,
            },
        },
        1024: {
            slidesPerView: 3,
            grid: {
                rows: 1,
            },
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 30,
            grid: {
                rows: 1,
            },
        },
    },
});


 function openPopup() {
    document.getElementById("videoPopup").style.display = "block";
    document.getElementById("videoPlayer").pause(); // Pause video when popup is opened
  }

  function closePopup() {
    document.getElementById("videoPopup").style.display = "none";
    document.getElementById("videoPlayer").play(); // Play video when popup is closed
  }